// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"9af2b4ab","572":"a633a452","821":"703e5453"}[chunkId] + ".chunk.css";
};